//@ts-check
import React from "react";

const ChunkOfNodes = props => {
    return <>{props.children}</>
}

export default ChunkOfNodes;